const GA_ID = process.env.REACT_APP_GA_ID;
const ADS_ID = "AW-18265693542";
const ADS_CALL_CONVERSION = "AW-18265693542/AkcFCOW95tIcEOa64YVE";
const BUSINESS_PHONE = "(615) 852-7141";
let loaded = false;

export function initAnalytics() {
  if (!GA_ID || loaded) return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
  // Google Ads "Calls from website" conversion — reuses the existing Google tag (no duplicate gtag.js).
  // Lets Google Ads swap the displayed number for a Google forwarding number on eligible ad traffic;
  // (615) 852-7141 remains the real destination.
  window.gtag("config", ADS_ID);
  window.gtag("config", ADS_CALL_CONVERSION, { phone_conversion_number: BUSINESS_PHONE });
}

let lastPath = null;

export function trackPageview(path) {
  if (loaded && window.gtag && path !== lastPath) {
    lastPath = path;
    window.gtag("config", GA_ID, { page_path: path });
    // Re-issue after SPA route changes so number substitution re-scans the newly rendered DOM
    window.gtag("config", ADS_CALL_CONVERSION, { phone_conversion_number: BUSINESS_PHONE });
  }
}

let webhookStatusPromise = null;
function calendlyWebhookEnabled() {
  if (!webhookStatusPromise) {
    webhookStatusPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tracking/status`)
      .then((r) => (r.ok ? r.json() : { webhook_enabled: false }))
      .then((d) => !!d.webhook_enabled)
      .catch(() => false);
  }
  return webhookStatusPromise;
}

// Fallback only: once the server-side Calendly webhook is configured it owns
// generate_lead and this stays silent, so a booking can never be double counted.
export async function trackBooking() {
  if (window.__hltBookingTracked) return;
  window.__hltBookingTracked = true;
  if (await calendlyWebhookEnabled()) return;
  if (loaded && window.gtag) {
    window.gtag("event", "generate_lead", {
      event_category: "booking",
      event_label: "calendly_consultation",
    });
  }
}

export function trackCall(source) {
  window.__hltCallTracked = true;
  if (loaded && window.gtag) {
    window.gtag("event", "phone_call_click", {
      event_category: "contact",
      event_label: source || "unknown",
    });
  }
}
